import React, { useEffect, useState } from "react";
import styles from "../RolesPermissonForm.module.scss";
import { Collapse } from "antd";
import {
  TruckingMaterialPermissions,
  CRMSectionConsts,
  checkboxNames,
  getActiveKeys,
} from "./constants";
import InputField from "../../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";
import { useFormContext } from "react-hook-form";

const CRMSectionOptions = () => {
  const { Panel } = Collapse;
  const { watch, setValue, getValues } = useFormContext();
  const [disabled, setDisabled] = useState<boolean>({
    [checkboxNames.TM_EDIT]: false,
    [checkboxNames.TM_VIEW]: false,
  });
  const {
    arrowPosition,
    borderedValue,
    OWNER_OPERATOR_LABEL,
    OWNER_OPERATOR_NAME,
    TRUCKING_MATERIAL_HEADER,
    TRUCKING_MATERIAL_KEY,
  } = CRMSectionConsts;

  const handleCheckboxChange = (name: string, val: boolean) => {
    switch (name) {
      case checkboxNames.TM_EDIT: {
        if (val) {
          setValue(checkboxNames.TM_VIEW, true);
          setDisabled((prev) => ({
            ...prev,
            [checkboxNames.TM_VIEW]: true,
          }));
        } else {
          setValue(checkboxNames.TM_VIEW, false);
          setDisabled(false);
        }
        break;
      }
      case checkboxNames.TM_INTERNAL_APPROVAL: {
        if (val) {
          setValue(checkboxNames.TM_VIEW, true);
          setValue(checkboxNames.TM_EDIT, true);
          setDisabled({
            [checkboxNames.TM_EDIT]: true,
            [checkboxNames.TM_VIEW]: true,
          });
        } else {
          setValue(checkboxNames.TM_VIEW, false);
          setValue(checkboxNames.TM_EDIT, false);
          setDisabled({
            [checkboxNames.TM_EDIT]: false,
            [checkboxNames.TM_VIEW]: false,
          });
        }
        break;
      }
    }
    setValue(name, val);
  };

  useEffect(() => {
    if (getValues(checkboxNames.TM_INTERNAL_APPROVAL)) {
      setDisabled({
        [checkboxNames.TM_EDIT]: true,
        [checkboxNames.TM_VIEW]: true,
      });
    } else if (getValues(checkboxNames.TM_EDIT)) {
      setDisabled({
        [checkboxNames.TM_VIEW]: true,
        [checkboxNames.TM_EDIT]: false,
      })
    }
  }, []);

  return (
    <>
      <Collapse
        ghost
        expandIconPosition={arrowPosition}
        bordered={borderedValue}
        defaultActiveKey={getActiveKeys(getValues())}
      >
        <Panel
          key={TRUCKING_MATERIAL_KEY}
          header={TRUCKING_MATERIAL_HEADER}
          className={styles.innerSection}
        >
          <div className={styles.checkboxContainer}>
            {TruckingMaterialPermissions?.map((item) => (
              <InputField
                name={item.name}
                label={item.label}
                type={InputfieldTypes.CHECKBOX}
                disabled={
                  item.name !== checkboxNames.TM_INTERNAL_APPROVAL
                    ? disabled?.[item.name]
                    : false
                }
                onChange={(val) => handleCheckboxChange(item.name, val)}
                value={watch(item.name)}
                defaultSwitch={watch(item.name)}
              />
            ))}
          </div>
        </Panel>
      </Collapse>
      <div className={styles.optionWrapper}>
        <span className={styles.optionTitle}>{OWNER_OPERATOR_LABEL}</span>
        <div className={styles.optionToggle}>
          <InputField
            name={OWNER_OPERATOR_NAME}
            type={InputfieldTypes.SWITCH}
            defaultSwitch={watch(OWNER_OPERATOR_NAME)}
            value={watch(OWNER_OPERATOR_NAME)}
          />
        </div>
      </div>
    </>
  );
};

export default CRMSectionOptions;
